import { createApp } from 'vue'
import App from '@/App.vue'
import 'survey-core/defaultV2.min.css'

const surveyElement = document.getElementById('survey-app')
if (surveyElement) {
  createApp(App).mount('#survey-app')
}